import { render, staticRenderFns } from "./formTextarea.vue?vue&type=template&id=30c6ca5d&scoped=true"
import script from "./formTextarea.vue?vue&type=script&lang=js"
export * from "./formTextarea.vue?vue&type=script&lang=js"
import style0 from "./formTextarea.vue?vue&type=style&index=0&id=30c6ca5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6ca5d",
  null
  
)

export default component.exports